<template>
  <v-container fluid>
    <v-card class="mb-6">
      <v-card-text>
        <h3>SELECIONE AS DATAS:</h3>
        <v-row class="mb-6">
          <v-col cols="12" sm="12" md="3">
            <Date
              @dateValue="[(filter.startDate = $event)]"
              label="Data Inicial"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <Date @dateValue="[(filter.endDate = $event)]" label="Data Final" />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              :items="prefectures"
              label="Prefeitura"
              v-model="filter.prefecture_id"
              item-value="prefecture_id"
              item-text="prefecture_social_name"
              clearable
              @change="getProviders(filter.prefecture_id)"
              :disabled="$store.getters.getUserData.table_key == 'prefectures' ? true : false"
            />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              :items="providers"
              label="Fornecedor"
              v-model="filter.provider_id"
              item-value="provider_id"
              item-text="provider_name"
              clearable
            />
          </v-col>
        </v-row>
        <v-footer absolute color="secondary">
          <v-btn color="secondary" depressed @click="sendSearch">FILTRAR</v-btn>
        </v-footer>
      </v-card-text>
    </v-card>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
        <v-spacer />
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark v-bind="attrs" v-on="on" to="/parts-and-services/nf/create">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar</span>
        </v-tooltip>
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark v-bind="attrs" v-on="on" @click="showSearch = !showSearch">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Pesquisar</span>
        </v-tooltip>
        <v-footer absolute color="primary" dark v-if="showSearch">
          <v-text-field
            class="search-field"
            v-model="search"
            color="#fff"
            placeholder="pesquisar"
            prepend-inner-icon="mdi-magnify"
            append-outer-icon="mdi-close"
            @click:append-outer="showSearch = !showSearch"
          />
        </v-footer>
      </v-toolbar>

      <v-card-actions>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="8"
          :loading="loader"
          loading-text="CARREGANDO..."
          class="elevation-0 maxPage"
        >
          <template v-slot:[`item.nf_issue_date`]="{ item }">
            <span>{{ convertDate(item.nf_issue_date) }}</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="$router.push(`/parts-and-services/nf/edit/${item.nf_id}`)"
                  color="primary"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small v-bind="attrs" v-on="on" @click="deleteItem(item.nf_id)" color="error">mdi-delete</v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-actions>
    </v-card>
    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import Date from "@/components/InputDate.vue";
export default {
  mixins: [Helpers],
  components: { Date },
  data: () => ({
    search: "",
    loader: true,
    showSearch: false,
    data: [],
    providers: [],
    prefectures: [],
    filter: {
      endDate: "",
      startDate: "",
      prefecture_id: null,
      provider_id: null,
    },
    snack: {
      show: false,
      message: "",
      color: "",
    },
    headers: [
      { text: "Nota Fiscal", value: "nf_number" },
      { text: "Pefeitura", value: "prefecture_social_name" },
      { text: "Participante", value: "provider_name" },
      { text: "Data de Emissão", value: "nf_issue_date" },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
  }),
  created() {
    if(this.$store.getters.getUserData.table_key == 'prefectures') {
      this.filter.prefecture_id = this.$store.getters.getUserData.table_id;
      this.getProviders(this.filter.prefecture_id);
    }
    this.Helpers;
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    this.loader = false;
  },
  methods: {
    sendSearch() {
      this.loader = true;
      this.$http
        .post("/parts-and-services/nf/conferences", this.filter)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.color = "error";
          this.snack.message = e.message;
          this.loader = false;
        });
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/parts-and-services/nf/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
    convertDate(date) {
      if (date) {
        date = date.replace("-", "").replace("-", "");
        const year = date.substring(0, 4);
        const month = date.substring(4, 6);
        const day = date.substring(6, 8);
        return `${day}/${month}/${year}`;
      } else {
        return false;
      }
    },
    getProviders(prefecture_id) {
      this.$http
        .get(`/parts-and-services/providers/prefecture/${prefecture_id}`)
        .then((r) => (this.providers = r.data));
    },
  },
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
</style>
